var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { defaultIconProps } from '../icon';
var SvgStyle = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  position: relative;\n  margin: 0 !important;\n  svg {\n    position: absolute;\n    top: 6px;\n    left: 6px;\n  }\n"], ["\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  position: relative;\n  margin: 0 !important;\n  svg {\n    position: absolute;\n    top: 6px;\n    left: 6px;\n  }\n"])));
export var IconDot = function (props) { return (_jsx(SvgStyle, __assign({ className: "icon icon__close" }, { children: _jsx("svg", __assign({ width: "4", height: "4", viewBox: "0 0 4 4", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z", fill: props.fill || defaultIconProps.fill }) })) }))); };
var templateObject_1;
